// extracted by mini-css-extract-plugin
export default {"button":"InviteButton_button__je7Ib"};